export default "__VITE_ASSET__aanQhjR3__"